export default "__VITE_ASSET__0aa87f01__"